(function () {
  'use strict';

  var SECTION_NAME = 'buy-box-smp-ajax';
  var LOADING_CLASS = 'buy-box-simplified__form--loading';
  var BTN_LOADING_CLASSES = [
    'buy-box-form-v2__button--loading',
    'buy-box-form-v3__button--loading',
    'buy-box-form-v4__button--loading'
  ];

  // Adds a stylesheet to <head> once (deduped by href). Used to keep the buy-box
  // form CSS loaded in a stable place so swapping the form container never tears it
  // down — which would otherwise reset the buy box font/styles on product switch.
  function ensureStylesheetInHead(href) {
    if (!href) return;
    var links = document.head.querySelectorAll('link[rel="stylesheet"]');
    for (var i = 0; i < links.length; i++) {
      if ((links[i].getAttribute('href') || '') === href) return;
    }
    var link = document.createElement('link');
    link.setAttribute('rel', 'stylesheet');
    link.setAttribute('href', href);
    document.head.appendChild(link);
  }

  function BuyBoxSmpAjax(tabsEl) {
    this.tabsEl = tabsEl;
    this.formContainer = tabsEl
      .closest('.buy-box-simplified')
      .querySelector('[data-buy-box-simplified-ajax-form]');

    if (!this.formContainer) return;

    // The form's stylesheet <link> is rendered INSIDE the form container, so an
    // innerHTML swap would tear it down (and the re-injected one may not re-apply),
    // changing the buy box font on product switch. Hoist it to <head> once so the
    // styles persist across every swap.
    this._hoistStylesheets(this.formContainer);

    // Flag: once set, OUR submit handler takes exclusive ownership of ATC.
    // Before the first swap, buy-box-form-v2/v3's own handler works normally.
    this._hasSwapped = false;

    // Permanent capture-phase listener on formContainer.
    // Capture fires BEFORE the form element's own bubble-phase listeners,
    // so after a swap we can intercept and destroy+redo the ATC event cleanly.
    this.formContainer.addEventListener(
      'submit',
      this._onFormSubmit.bind(this),
      true // capture
    );

    this.tabsEl.addEventListener('click', this._onTabClick.bind(this));
  }

  // Move any stylesheet links found in `scope` into <head> (deduped) and remove them
  // from the scope, so the CSS lives in a stable place that swaps can't destroy.
  BuyBoxSmpAjax.prototype._hoistStylesheets = function (scope) {
    if (!scope) return;
    var links = scope.querySelectorAll('link[rel="stylesheet"]');
    Array.prototype.forEach.call(links, function (link) {
      ensureStylesheetInHead(link.getAttribute('href'));
      link.remove();
    });
  };

  // v2/v3 radios carry the type in their value; v4 radios carry an option key in the
  // value and the type in data-purchase-type.
  BuyBoxSmpAjax.prototype._getPurchaseType = function () {
    var checked = this.formContainer.querySelector('[data-purchase-type]:checked');
    if (!checked) return 'subscription';
    return checked.dataset.purchaseType || checked.value;
  };

  // ─── ATC handler (takes over after first swap) ───────────────────────────────
  BuyBoxSmpAjax.prototype._onFormSubmit = function (e) {
    // Before the first swap the original buy-box-form-v2/v3 handles ATC.
    if (!this._hasSwapped) return;

    // Destroy the original event so buy-box-form-v2/v3's listener never fires.
    e.preventDefault();
    e.stopImmediatePropagation();

    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;

    var button = form.querySelector('[data-atc-button]');
    var purchaseType = this._getPurchaseType();
    var self = this;

    var formData = new FormData(form);
    if (purchaseType !== 'subscription') {
      formData.delete('selling_plan');
    }

    if (button) {
      button.disabled = true;
      BTN_LOADING_CLASSES.forEach(function (c) { button.classList.add(c); });
    }

    fetch('/cart/add.js', { method: 'POST', body: formData })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function (cartItem) {
        // Fire cart:add events so cart-drawer-custom.js and other listeners update.
        var detail = { cart: cartItem };
        document.dispatchEvent(new CustomEvent('cart:add', { bubbles: true, detail: detail }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:add', { bubbles: true, detail: detail }));

        // Click the hidden trigger that opens the cart drawer.
        var trigger = document.querySelector('.js-open-cart-drawer-trigger') ||
                      document.querySelector('.js-offcanvas-trigger[data-drawer-name="cart"]');
        if (trigger instanceof HTMLElement) trigger.click();

        if (button) {
          button.disabled = false;
          BTN_LOADING_CLASSES.forEach(function (c) { button.classList.remove(c); });
        }
      })
      .catch(function () {
        if (button) {
          button.disabled = false;
          BTN_LOADING_CLASSES.forEach(function (c) { button.classList.remove(c); });
        }
        form.submit();
      });
  };

  // ─── Tab click → SSR swap ────────────────────────────────────────────────────
  BuyBoxSmpAjax.prototype._onTabClick = function (e) {
    var tab = e.target.closest('[data-smp-product-handle]');
    if (!tab || tab.getAttribute('aria-pressed') === 'true') return;

    var handle = tab.dataset.smpProductHandle;
    var purchaseType = this._getPurchaseType();

    this.tabsEl.setAttribute('aria-busy', 'true');
    this.formContainer.classList.add(LOADING_CLASS);

    var self = this;
    fetch('/products/' + handle + '?sections=' + SECTION_NAME)
      .then(function (resp) {
        if (!resp.ok) throw new Error('HTTP ' + resp.status);
        return resp.json();
      })
      .then(function (data) {
        var sectionHtml = data[SECTION_NAME];
        if (!sectionHtml) throw new Error('Section not found in SSR response');

        var parser = new DOMParser();
        var doc = parser.parseFromString(sectionHtml, 'text/html');
        var newForm = doc.querySelector('[data-buy-box-smp-ajax-form]');
        if (!newForm) throw new Error('Form wrapper missing in SSR response');

        var tempDiv = document.createElement('div');
        tempDiv.innerHTML = newForm.innerHTML;

        // Injected <script src> tags don't execute — remove for clean DOM.
        tempDiv.querySelectorAll('script[src]').forEach(function (el) {
          el.remove();
        });

        // Hoist the form stylesheet to <head> (deduped) instead of re-inserting it
        // into the swapped container, so the buy box font/styles never reset.
        self._hoistStylesheets(tempDiv);

        // Place JSON data scripts FIRST so the custom element's connectedCallback
        // finds them immediately (before its own children are queryable).
        var dataScripts = Array.from(
          tempDiv.querySelectorAll('script[type="application/json"]')
        );
        var dataHtml = dataScripts.map(function (s) {
          s.remove();
          return s.outerHTML;
        }).join('');

        self.formContainer.innerHTML = dataHtml + tempDiv.innerHTML;

        // Hand ATC ownership to our capture listener from this point on.
        self._hasSwapped = true;

        // Update active tab state.
        self.tabsEl.querySelectorAll('[data-smp-product-handle]').forEach(function (t) {
          var isActive = t.dataset.smpProductHandle === handle;
          t.setAttribute('aria-pressed', String(isActive));
          t.classList.toggle('buy-box-simplified__smp-tab--active', isActive);
        });

        // Let the custom element initialize for UI behaviours (price display,
        // variant/plan switching). ATC is now handled by _onFormSubmit above.
        requestAnimationFrame(function () {
          var formEl = self.formContainer.querySelector('buy-box-form-v2') ||
                       self.formContainer.querySelector('buy-box-form-v3') ||
                       self.formContainer.querySelector('buy-box-form-v4');
          if (formEl && typeof formEl.init === 'function') {
            formEl.init();
          }

          // Restore purchase-type selection.
          if (purchaseType === 'one-time') {
            var oneTimeHeader = self.formContainer.querySelector(
              '[data-plan-type="one-time"] [data-plan-header]'
            );
            if (oneTimeHeader) oneTimeHeader.click();
          }
        });
      })
      .catch(function (err) {
        console.error('[BuyBoxSmpAjax]', err);
      })
      .finally(function () {
        self.tabsEl.removeAttribute('aria-busy');
        self.formContainer.classList.remove(LOADING_CLASS);
      });
  };

  // ─── Init ────────────────────────────────────────────────────────────────────
  function init() {
    document.querySelectorAll('[data-smp-ajax-tabs]').forEach(function (el) {
      new BuyBoxSmpAjax(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
